
import { useParams, Link } from 'react-router-dom';
import { PersonaAwareHeader } from '@/utils/headerUtils';
import { useProduct } from '@/hooks/useProduct';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { ProductHeader } from '@/components/product/ProductHeader';
import { VerificationScorecard } from '@/components/product/VerificationScorecard';
import { CertificationInformation } from '@/components/product/CertificationInformation';
import { ProductInformation } from '@/components/product/ProductInformation';
import { ProductTabs } from '@/components/product/ProductTabs';

const ProductDetail = () => {
  const { portfolioId, productId } = useParams<{ portfolioId: string; productId: string }>();
  const { product, isLoading, error } = useProduct(productId || '');

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <PersonaAwareHeader />
        <main className="container py-12">
          <div className="flex justify-center items-center h-64">
            <p>Loading product details...</p>
          </div>
        </main>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="min-h-screen bg-background">
        <PersonaAwareHeader />
        <main className="container py-12">
          <div className="bg-destructive/10 p-4 rounded-md text-destructive mb-6">
            Product not found or you don't have access to view it.
          </div>
          <Link to={`/client/portfolios/${portfolioId}`}>
            <Button variant="outline" className="flex items-center gap-2">
              <ArrowLeft className="h-4 w-4" />
              Back to Portfolio
            </Button>
          </Link>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <PersonaAwareHeader />
      
      <main className="container py-12">
        <ProductHeader product={product} portfolioId={portfolioId || ''} />

        {/* Verification Scorecard */}
        <VerificationScorecard product={product} />

        {/* Certification Information */}
        <CertificationInformation product={product} />

        {/* Basic Information Card */}
        <ProductInformation product={product} />

        {/* Tabs for Related Information */}
        <ProductTabs />
      </main>
    </div>
  );
};

export default ProductDetail;
